<template>
  <NaviDesktopLayout>
    <template #layout-left>
      <NaviSerializeRenderList
        :list-options="NAVI_LIST_OPTIONS_LAYOUT_LEFT"
      />
      <SearchPanel
        v-if="props.shouldShowSearchPanel"
        :direct-stock-method="searchPanelDirectStockMethod"
      />
    </template>
    <template #layout-right>
      <template v-if="isSignedIn">
        <NaviSerializeRenderList :list-options="NAVI_LIST_OPTIONS_LAYOUT_RIGHT" />
      </template>
      <template v-else>
        <NaviSerializeRenderList :list-options="NOT_SIGNED_IN_NAVI_LIST_OPTIONS_LAYOUT_RIGHT" />
      </template>
    </template>
  </NaviDesktopLayout>
</template>

<script setup>
import { computed } from 'vue'

import SearchPanel from '@/modules/search_panel/desktop'
import { WINDOW_LOCATION, VUE_ROUTER } from '@/modules/search_panel/constants/direct_method'
import useUserStore from '@/modules/shared/store/useUserStore'

import {
  NAVI_LIST_OPTIONS_LAYOUT_LEFT,
  NAVI_LIST_OPTIONS_LAYOUT_RIGHT,
  NOT_SIGNED_IN_NAVI_LIST_OPTIONS_LAYOUT_RIGHT,
} from '../constants/navi_list_options'

import NaviDesktopLayout from './NaviDesktopLayout.vue'
import NaviSerializeRenderList from './NaviSerializeRenderList.vue'

const props = defineProps({
  useVueRouter: {
    type: Boolean,
    default: false,
  },
  shouldShowSearchPanel: {
    type: Boolean,
    default: true,
  },
})

const searchPanelDirectStockMethod = computed(() => (
  props.useVueRouter ? VUE_ROUTER : WINDOW_LOCATION
))

const { isSignedIn } = useUserStore()
</script>
